import React, { useState } from 'react';

const initialState = {
  user: {
    name: "Nome de Usuário Inicial",
    saldo: 0,
    numpedido: []
  }
}

const setUser = (state, setState, user, saldo) => {
    setState({user, saldo})
  }

export const AuthContext = React.createContext({
  state: initialState,
  actions: {
    setUser: () => {}
  }
});


export const AuthContextProvider = props => {
    const [state, _setState] = useState(initialState)

    const setState = (_state) => {
        const newState = { ...state, ..._state }
        _setState(newState)
    }

    const actions = {
        setUser: setUser.bind(null, state, setState)
    }

    return (
        <AuthContext.Provider value={{ state, actions }} >
            {props.children}
        </AuthContext.Provider>
    );
}